export enum AppLogoTypes {
  GENERAL = 'general',
  HEADER = 'header',
  REGISTRATION = 'registration',
  REGISTRATION_MOBILE = 'registration-mobile',
}
